<script lang="ts" setup>
import {
  BlockCarouselManualFields,
  BlockCoverNavigationFields,
  BlockFooterCTAFields,
  BlockImageTextFields,
  BlockProjectStatsFields,
  BlockSingleQuoteFields,
} from '~/utils/CmsBlockFields'

const { $directus, $readSingleton } = useNuxtApp()

const { data } = await useAsyncData('project_overview', async () => {
  return $directus.request($readSingleton('project_overview', {
    fields: ['*', {
      seo: ['*', {
        translations: ['*'],
      }],
      translations: ['*'],
      hero_image: ['*'],
      hero_video: ['*'],

      blocks: [
        'collection',
        'id',
        {
          item: {
            block_carousel_manual: BlockCarouselManualFields, //
            block_cover_navigation: BlockCoverNavigationFields, //
            block_single_quote: BlockSingleQuoteFields, //
            block_image_text: BlockImageTextFields, //
            block_footer_cta: BlockFooterCTAFields, //
            // Project specific
            block_project_stats: BlockProjectStatsFields, //
            block_project_index: ['*'], //
          },
        },
      ],
    }],
  }))
})
</script>

<template>
  <div>
    <HeroIndex :data="(data as any)" />
    <div>
      <!-- <pre>{{ data }}</pre> -->
      <div v-for="block in data?.blocks" :key="block.id">
        <BlockPoolNavigation v-if="block.collection === 'block_cover_navigation'" />
        <BlockSingleQuote v-if="block.collection === 'block_single_quote'" :data="block.item" />
        <BlockImageText v-if="block.collection === 'block_image_text'" :data="block.item" />
        <BlockCarouselManual v-if="block.collection === 'block_carousel_manual'" :data="block.item" />
        <BlockFooterCTA v-if="block.collection === 'block_footer_cta'" :data="block.item" />
        <!-- Project specific -->
        <BlockProjectStats v-if="block.collection === 'block_project_stats'" :data="block.item" />
        <BlockProjectIndex v-if="block.collection === 'block_project_index'" />
      </div>
    </div>
  </div>
</template>

<style>

</style>
